<template>
  <v-container>
    <v-card>
      <v-card-title>
        <v-spacer/>
        <v-spacer/>
        <v-spacer/>
        <v-spacer/>
        <v-text-field
          v-model="search"
          append-icon="search"
          label="Procurar"
          hide-details/>
      </v-card-title>

      <v-data-table
        :headers="headers"
        :items="devices"
        :search="search"
        hide-actions
        class="elevation-1">
        <template slot="items" slot-scope="props">
          <td v-if="isAdmin">{{ props.item['.key'] }}</td>
          <td v-if="isAdmin">{{ props.item.config.companyName }}</td>
          <td>{{ props.item.config.room }}</td>
          <td>{{ props.item.config.worklistResource }}</td>
          <td>{{ props.item.status }}</td>
          <td>{{ props.item.memoryInfo ? props.item.memoryInfo.availableInternalMemorySize : '' }}</td>
          <td>{{ props.item.config.appVersion }}</td>
          <td class="justify-center layout px-0">
            <v-btn
              @click="openConfig(props.item['.key'])"
              icon>
              <v-icon color="primary">settings</v-icon>
            </v-btn>
          </td>
        </template>
      </v-data-table>
    </v-card>

    <v-dialog v-model="dialog" persistent max-width="350">
      <v-card>
        <v-card-title class="headline">Configurações de Imagem</v-card-title>
        <v-card-text v-if="device" class="px-4">
           <v-layout
            v-for="item in imageAttr"
            :key="'imageAttr' + item.value"
            row>
              <v-flex style="width: 80px; padding-top: 20px;">
                {{item.text}}
              </v-flex>
              <v-flex>
                <v-slider
                  hide-details
                  thumb-label
                  v-model="device.image[item.value]"
                  @input="updateConfigImage($event, item.value)">
                </v-slider>
              </v-flex>
           </v-layout>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn flat @click.native="dialog = false">Fechar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import {db} from '../store/firebase'
import {mapState} from 'vuex'

export default {
  computed: {
    ...mapState({
      user: state => state.user,
      isAdmin: state => state.user.role === 'admin',
      company: state => state.company
    }),
    headers () {
      let header = [
        { text: 'Sala', value: 'config.room' },
        { text: 'Recurso', value: 'config.worklistResource' },
        { text: 'Status', value: 'status' },
        { text: 'Espaço', value: 'memoryInfo.availableInternalMemorySize' },
        { text: 'Versão', value: 'config.appVersion' },
        { text: 'Ações', value: 'actions', sortable: false, align: 'center' }
      ]

      if (this.isAdmin) {
        header.unshift({ text: 'Empresa', value: 'config.companyName' })
        header.unshift({ text: 'Equipamento', value: '.key' })
      }

      return header
    }
  },
  data () {
    return {
      imageAttr: [
        { text: 'Brilho', value: 'brightness' },
        { text: 'Contraste', value: 'contrast' },
        { text: 'Matiz', value: 'hue' },
        { text: 'Saturação', value: 'saturation' },
        { text: 'Gama', value: 'gamma' },
        { text: 'Ganho', value: 'gain' }
      ],
      dialog: false,
      device: null,
      search: ''
    }
  },
  firebase () {
    return {
      devices: this.isAdmin
        ? db.ref('devices').orderByChild('config/company')
        : db.ref('devices').orderByChild('config/company').equalTo(this.$store.state.company)
    }
  },
  methods: {
    openConfig (key) {
      this.device = this.devices.filter(item => item['.key'] === key)[0]
      if (!this.device.image) {
        this.device.image = {}
      }
      this.dialog = true
    },
    async updateConfigImage (val, attr) {
      let update = {}
      update[`/image/${attr}`] = val
      db.ref(`devices/${this.device['.key']}`).update(update)
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/Devices.vue